// Generated by ReScript, PLEASE EDIT WITH CARE

import * as TerminationStateMapper from "../entity-mapper/TerminationStateMapper.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";

function execute(data) {
  return TerminationStateMapper.TerminationInfo.builder(data);
}

var TerminationInfoResponseConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var TerminationInfoResponseConverter = partial_arg(TerminationInfoResponseConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$1(data) {
  return TerminationStateMapper.TerminationReasons.builder(data);
}

var TerminationReasonsResponseConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var TerminationReasonsResponseConverter = partial_arg$1(TerminationReasonsResponseConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  TerminationInfoResponseConfig ,
  TerminationInfoResponseConverter ,
  TerminationReasonsResponseConfig ,
  TerminationReasonsResponseConverter ,
  
}
/* TerminationInfoResponseConverter Not a pure module */
